import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterQuoteItem } from 'models/IBlotterItem';
import type {
  ActivityFilter,
  DateFilter,
  IBlotterColumnDefinition,
  PlatformFilter,
  ProductFilter,
  Sort,
} from 'state/blotters/common/blotter.model';

export interface IQuoteBlotterFilters {
  quickSearchTerm: string;
  dateFilter: DateFilter;
  activityFilter: ActivityFilter;
  productFilter: ProductFilter;
  platformFilter: PlatformFilter;
  advancedFilters: boolean;
  currencyFilter: string;
  startDate?: string;
  endDate?: string;
  deskFilter: number | null;
}

export type IQuoteBlotterFiltersWithMandatoryDates = Required<IQuoteBlotterFilters>;

export interface IQuoteBlotter {
  blotterPreferenceState: IBlotterPreferenceState;
  areBlotterPreferencesInError: boolean;
  canSaveBlotterPreferences: boolean;
  isQuoteBlotterPreferenceStatePersistenceFailed: boolean;

  columnDefinition: readonly IBlotterColumnDefinition<IBlotterQuoteItem>[];

  availablePlatforms: ReadonlyArray<PlatformFilter> | null;
  availablePlatformsFetchingStatus: 'loading' | 'error' | 'success' | null;

  isFetchingFailed: boolean;
  isFiltersLoadingFailed?: boolean;

  loading: boolean;
  page: number;
  sort: readonly Sort[];

  filters: IQuoteBlotterFilters;
}

export type QuoteBlotterState = Readonly<IQuoteBlotter>;

export const initialQuoteBlotterFilters: IQuoteBlotterFilters = {
  quickSearchTerm: '',
  activityFilter: 'mySelf',
  dateFilter: 'today',
  productFilter: 'allProducts',
  platformFilter: 'allPlatforms',
  advancedFilters: false,
  currencyFilter: 'allCurrencies',
  startDate: undefined,
  endDate: undefined,
  deskFilter: null,
};

export const initialQuoteBlotterState: QuoteBlotterState = {
  filters: initialQuoteBlotterFilters,
  page: 1,
  loading: true,
  blotterPreferenceState: {
    columnState: [],
    pageSizeState: 25,
  },
  sort: [],
  columnDefinition: [],
  isFetchingFailed: false,
  isFiltersLoadingFailed: false,
  isQuoteBlotterPreferenceStatePersistenceFailed: false,
  areBlotterPreferencesInError: false,
  canSaveBlotterPreferences: false,
  availablePlatforms: null,
  availablePlatformsFetchingStatus: null,
};
